<template>
  <div class="home">
      <div class="container">
        <img src="@/assets/images/about1.png" class="img-fluid"/>
      </div>
    <!-- What is TSK -->
    <div id="about">
      <div class="container pt-5">
        <div class="row align-items-center">
          <div class="col-lg-6 col-sm-10 center">
            <iframe class="w-100" src="https://www.youtube.com/embed/QlfMgvHVR6Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
          <div class="col-lg-6 col-sm-10 text-start center">
            <div class="row row-cols-1">
              <div class="col px-3 py-4 p-lg-5">
                <p class="h2 text-primary" v-html="$t('about.title1')"></p>
                <p class="about-heading text-primary" style="font-size: 20px;" v-html="$t('about.title2')"></p>
                <p class="about-copy text-dark-gray" style="font-size: 16px;" v-html="$t('about.description')"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CEO圖-->
    <div id="CEO">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-4 col-sm-10 center">
            <img src="@/assets/images/ceo.jpg" class="img-fluid"/>
          </div>
          <div class="col-lg-8 col-sm-10 text-start center">
            <div class="row row-cols-1">
              <div class="col px-3 py-4 p-lg-5">
                <p class="about-heading h2 text-primary" v-html="$t('about.contribution1')"></p>
                <div style="height: 20px;"></div>
                <p class="about-copy text-dark-gray" style="font-size: 16px;" v-html="$t('about.contribution2')"></p>
                <div style="height: 20px;"></div>
                <p class="about-signature text-black" style="font-size: 16px;" v-html="$t('about.contribution3')"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Vision & values-->
    <div id="Vision">
      <div class="container py-5">
        <h1 class="h2 text-start">Vision & values<span class="icon-report_close" style="vertical-align: middle; margin-left: 5px;"></span></h1>

        <div class="row">
          <div class="col-lg-6 col-sm-10 text-start text-dark-gray" style="font-size: 16px;">
            <p class="about-copy" v-html="$t('about.Vision1')"></p>
          </div>
          <div class="col-lg-6 col-sm-10 text-start text-dark-gray" style="font-size: 16px;">
            <p class="about-copy" v-html="$t('about.Vision2')"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- 工廠圖 -->
    <div id="">
      <div class="container">
        <img src="@/assets/images/about3.png" class="img-fluid"/>
      </div>
    </div>
    <!-- Needle innovations-->
    <div id="Needle" hidden>
      <div class="container py-5">
        <h1 class="h2 text-start">Needle innovations<span class="icon-report_close" style="vertical-align: middle; margin-left: 5px;"></span></h1>

        <div class="row">
          <div class="col-lg-6 col-sm-10 text-start text-dark-gray" style="font-size: 16px;">
            <ul class="innovation-list">
              <li>{{ $t("about.Needle1-1") }}</li>
              <li>{{ $t("about.Needle1-2") }}</li>
              <li>{{ $t("about.Needle1-3") }}</li>
              <li>{{ $t("about.Needle1-4") }}</li>
              <li>{{ $t("about.Needle1-5") }}</li>
            </ul>
          </div>
          <div class="col-lg-6 col-sm-10 text-start text-dark-gray" style="font-size: 16px;">
            <ul class="innovation-list">
              <li>{{ $t("about.Needle2-1") }}</li>
              <li>{{ $t("about.Needle2-2") }}</li>
              <li>{{ $t("about.Needle2-3") }}</li>
              <li>{{ $t("about.Needle2-4") }}</li>
              <li>{{ $t("about.Needle2-5") }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- TSK non-stop-->
    <div id="TSK">
      <div class="container center my-5 text-primary">
      <h5 class="innovation-closing">
        <span>{{$t("about.Fin1")}}</span>
        <span>{{$t("about.Fin2")}}</span>
        <span>{{$t("about.Fin3")}}</span>
      </h5>
      </div>  
    </div>
    <!-- 聯絡我們 -->
    <ContactFooter />
  </div>
</template>

<script>
// @ is an alias to /src
import product from "@/config/product.js";
import ContactFooter from '@/components/ContactFooter.vue'

export default {
  name: "Home",
  components: {
    ContactFooter
  },
  data() {
    return {
      product: product
    };
  },
};
</script>

<style lang="scss">
.home .h2 {
  font-size: 24px;
}

.about-heading {
  line-height: 1.45;
}
.about-copy {
  line-height: 1.9;
  text-align: justify;
  text-justify: inter-ideograph;
}
.about-signature {
  line-height: 1.8;
}
.innovation-list {
  line-height: 2.2;
}
.innovation-closing {
  display: grid;
  gap: 0.65rem;
  line-height: 1.6;
  letter-spacing: 0.12em;
}
#contact {
  p {
    margin: 0;
  }
}
</style>
